module.exports = __webpack_public_path__ + "img/book1.9fd80d8e.svg";